export const isDev = () =>
  typeof window === 'undefined' ? false : window?.gConfig?.ENV === 'dev';
